import React, { Component } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { withStyles } from '@mui/styles'

const styles = theme => ({
  text: {
    whiteSpace: 'pre-wrap'
  }
})

class ErrorModal extends Component {

  render() {
    // console.log('this.props:',this.props)
    const details = this.props.customReason || (this.props.statusCode === 404
      ? "Oops! This page cannot be found"
      : "")

    return (
      <Dialog open={Boolean(this.props.show)} onClose={this.props.onHide} maxWidth="sm" fullWidth>
        <DialogTitle>
          <pre style={{ fontFamily: 'inherit' }}>
            {details}
          </pre>
        </DialogTitle>
        <DialogContent>{"Error " + this.props.statusCode + ":  " + this.props.reasonPhrase}</DialogContent>
        <DialogContent>
          Click OK to continue
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onHide} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
// @ts-ignore
export default withStyles(styles)(ErrorModal)

